define.alias("shared/components/shared/credentials/tiktok-refresh-confirm", "media/components/shared/credentials/tiktok-refresh-confirm");